import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  BCTX_KEYS_TO_DISPLAY_MAP,
  TBctxItemWithoutSizeAndBctxKey,
  TBCTXKeysWithoutSize,
  TBusinessContextListingItemFilter,
  TPaginationInfo,
  BCTX_KEYS_TO_FILTER_TITLES,
  TBCTXKeys,
  TBctxSelectionButton,
  TOnBctxSelectionEmittedData,
} from '@monorepo/types';
import { TFilterGroupModel, TTableTreeModel, TUserPaginationOption } from '@monorepo/ui';
import { BCTX_SELECTION_LISTING_MODEL } from './bctx-selection-listing.model';
import { BCTX_SELECTION_FILTER_MODEL } from './bctx-selection-filter.model';

@Component({
  selector: 'monorepo-bctx-selection',
  templateUrl: './bctx-selection.component.html',
  styleUrls: ['./bctx-selection.component.scss'],
})
export class BctxSelectionComponent implements OnInit, OnChanges {
  @Input() header: string = 'bctx_selection.heading';
  @Input() bctxList: TBctxItemWithoutSizeAndBctxKey[] = [];
  @Input() orderKeys: TBCTXKeysWithoutSize[] = [];
  @Input() enableProceed = false;
  @Input() buttonTxt = '';
  @Input() bctxKeysToDisplayMap = BCTX_KEYS_TO_DISPLAY_MAP;
  @Input() bctxKeysToFilterTitles = BCTX_KEYS_TO_FILTER_TITLES;
  @Input() hideSync = false;
  @Input() hideExit = false;

  @Input() minCharacterLength: Record<TBCTXKeys, number> | undefined;
  @Input() selectedBctxItem: TBctxItemWithoutSizeAndBctxKey[] = [];
  @Input() buttonList: TBctxSelectionButton[] = [];

  @Output() onClose = new EventEmitter<'CLOSE'>();
  @Output() onSync = new EventEmitter<'SYNC'>();
  @Output() onBctxSelection = new EventEmitter<TBctxItemWithoutSizeAndBctxKey>();
  @Output() onBctxSelectionForButtonList = new EventEmitter<TOnBctxSelectionEmittedData>();

  selectedBctxItems: TBctxItemWithoutSizeAndBctxKey[] = [];
  tableBctxListingModel: TTableTreeModel<TBctxItemWithoutSizeAndBctxKey> = BCTX_SELECTION_LISTING_MODEL.createModel(
    [],
    this.orderKeys,
    this.bctxKeysToDisplayMap,
  );

  bctxListingFilterGroupModel: TFilterGroupModel<TBusinessContextListingItemFilter> = {
    groups: [],
    hasSelectedFilters: false,
    selectedFilters: [],
    originalData: [],
    isValid: true,
  };

  userPaginationOption: TUserPaginationOption = {
    pageNo: 1,
    pageSize: 10,
  };

  paginationInfo: TPaginationInfo = {
    totalPageCount: 1,
    itemsPerPage: 10,
    totalItems: 1,
    rangeInPage: {
      start: 1,
      end: 10,
    },
  };

  syncIcon = '/assets/common/sync-blue-icon.svg';
  proceedIcon = '../../../assets/fabric-inspection/proceed-icon.svg';
  exitIcon = '../../../assets/fabric-inspection/exit-icon.svg';

  constructor() {}

  ngOnInit(): void {
    console.log('[bctxList]', this.bctxList);
    console.log('[orderKeys]', this.orderKeys);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bctxList']) {
      this.setUpTableAndFilterModel();
    }
  }

  onTableSelect($event: TBctxItemWithoutSizeAndBctxKey[]) {
    if (this.enableProceed) this.selectedBctxItems = $event;
    else this.sendChangeBctxEvent();
  }

  closeModal() {
    this.onClose.emit('CLOSE');
  }

  sendChangeBctxEvent() {
    this.onBctxSelection.emit(this.selectedBctxItems[0]);
  }

  setUpTableAndFilterModel() {
    const selectedFilters = this.bctxListingFilterGroupModel.selectedFilters.map((item) => {
      return {
        filterType: item.key as TBusinessContextListingItemFilter['filterType'],
        values: item.values as (string | number)[],
      };
    });
    const { paginationInfo, supportedFilters, paginatedFilteredBctxList } =
      BCTX_SELECTION_FILTER_MODEL.getFilterBctxList(
        selectedFilters,
        this.bctxList,
        this.userPaginationOption,
        this.orderKeys,
      );
    this.paginationInfo = paginationInfo;
    this.tableBctxListingModel = BCTX_SELECTION_LISTING_MODEL.createModel(
      paginatedFilteredBctxList,
      this.orderKeys,
      this.bctxKeysToDisplayMap,
    );
    this.bctxListingFilterGroupModel = BCTX_SELECTION_FILTER_MODEL.createModel(
      supportedFilters,
      this.bctxListingFilterGroupModel,
      this.bctxKeysToFilterTitles,
      this.minCharacterLength,
    );
  }

  onUpdateFilter($event: TFilterGroupModel<TBusinessContextListingItemFilter>) {
    this.bctxListingFilterGroupModel = $event;
    this.setUpTableAndFilterModel();
  }

  updateUserPagination($event: TUserPaginationOption) {
    this.userPaginationOption = $event;
    this.setUpTableAndFilterModel();
    console.log('[Pagination option]', this.userPaginationOption);
    console.log('[PaginatonInfo', this.paginationInfo);
  }

  handleSync() {
    this.onSync.emit('SYNC');
  }

  sendChangeBctxEventForButtonList(btn: TBctxSelectionButton) {
    this.onBctxSelectionForButtonList.emit({ button: btn, bctxItem: this.selectedBctxItems[0] });
  }
}
